// The iOS-style on/off pill used across notification settings, plus the tappable
// cell wrapper the per-channel matrix and the per-item lists share. Lives on its
// own so NotificationPrefs and NotificationSources can both use it without one
// importing the other. Tap target is ≥40px wide (mobile-first).
export default function Switch({ on, busy, size = 'md' }) {
  const w = size === 'sm' ? 32 : 36, h = size === 'sm' ? 19 : 21, k = h - 4;
  return (
    <span style={{ width: w, height: h, borderRadius: 999, background: on ? 'var(--brand)' : 'rgba(128,128,128,0.35)', position: 'relative', flexShrink: 0, transition: 'background 0.15s', opacity: busy ? 0.5 : 1 }}>
      <span style={{ position: 'absolute', top: 2, left: on ? w - k - 2 : 2, width: k, height: k, borderRadius: '50%', background: '#fff', transition: 'left 0.15s', boxShadow: '0 1px 2px rgba(0,0,0,0.3)' }} />
    </span>
  );
}

// One channel/type cell. `dimmed` means the value is kept but something above it
// (a master channel that's off, a muted event) is currently overriding it.
export function MiniToggle({ on, busy, dimmed, onClick, title, size }) {
  return (
    <button onClick={onClick} disabled={busy} title={title} aria-pressed={!!on}
      style={{ width: 44, minHeight: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', padding: 0, cursor: busy ? 'default' : 'pointer', opacity: dimmed ? 0.4 : 1 }}>
      <Switch on={on} busy={busy} size={size} />
    </button>
  );
}
